var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 200,
    viewBox: "0 0 238 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.196 106L21.7964 53.9L112.196 1.80005L202.496 53.9L112.196 106Z",
    fill: "#F6CA9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9964 52.2L111.396 0L90.7964 23.8L0.396423 75.9L20.9964 52.2Z",
    fill: "#D2A06F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7964 53.9L112.196 1.80005L91.5964 25.5L1.19641 77.7L21.7964 53.9Z",
    fill: "#91633E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.396 199.8L56.9964 147.7L147.396 95.5L237.696 147.7L147.396 199.8Z",
    fill: "#404D5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.396 171.4H112.096V199.9H147.396V171.4Z",
    fill: "#404D5C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.889 0.353686L89.5449 24.0586L90.8825 25.263L112.227 1.55808L110.889 0.353686Z",
    fill: "#D2A06F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.196 106L21.7964 53.8999L112.196 1.69995L202.496 53.8999L112.196 106Z",
    fill: "#F6CA9F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6964 56.3999L112.096 4.19995V95.5999L21.6964 147.8V56.3999Z",
    fill: "#B68156"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.896 4.09998L202.296 56.2V147.8L111.896 95.6V4.09998Z",
    fill: "#91633E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6964 53.6L112.096 105.8V199.8L21.6964 147.7V53.6Z",
    fill: "#D2A06F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.996 4.19995L184.896 137.7L111.996 95.5999V4.19995Z",
    fill: "#6C492D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.096 106.2L202.396 54.1V147.9L112.096 200V106.2Z",
    fill: "#91633E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.096 137.5C179.596 136.8 180.096 136.1 180.696 135.6C181.396 134.8 182.196 134.1 183.096 133.4C183.696 132.9 184.596 132.4 185.596 131.7L185.796 130.9L186.096 130.5C186.296 130.4 186.396 130.5 186.496 130.6C186.596 130.7 186.596 130.8 186.696 131C187.796 130.4 188.696 130 189.596 129.7C190.596 129.3 191.496 129.2 192.296 129.2C192.596 129.2 192.896 129.3 193.196 129.3C194.096 129.6 194.696 130.2 194.996 130.9C195.096 131.1 195.096 131.3 195.196 131.6C195.196 131.6 195.196 131.9 195.296 132.3C194.796 132.3 194.196 132.4 193.496 132.8C192.796 133.2 192.196 133.7 191.696 134.4L191.596 134.5C191.096 134.4 190.596 134.6 189.996 134.9C189.396 135.2 188.896 135.7 188.396 136.3C187.896 136.2 187.296 136.4 186.496 137C186.496 142.3 186.496 145.5 186.496 146.6C186.496 146.8 186.396 147.1 186.296 147.4C186.196 147.7 185.996 147.9 185.696 148.2C185.296 148.6 184.796 149 184.296 149.2C183.796 149.4 183.396 149.5 182.996 149.5C182.696 149.4 182.496 149.1 182.496 148.4L183.096 148.1C183.096 148.4 183.096 148.6 183.296 148.7C183.496 148.8 183.596 148.9 183.896 148.8C184.596 148.5 185.096 148.2 185.496 147.6C185.696 147.4 185.696 147.1 185.796 146.8C185.796 146.5 185.796 146.3 185.796 146.1V137.3C185.496 137.4 185.196 137.6 184.896 137.8C184.596 138.1 184.296 138.4 184.096 138.7L183.796 138.6C183.296 138.6 182.796 138.8 182.296 139.2C181.796 139.5 181.296 140 180.796 140.6C180.296 140.5 179.696 140.7 179.096 141.1C178.496 141.4 177.896 141.9 177.296 142.6L177.196 142.8C177.196 142.6 177.196 142.4 177.196 142.1C177.396 141.4 177.496 140.8 177.596 140.4L177.896 139.6C178.196 138.9 178.596 138.2 179.096 137.5ZM183.296 131.7C183.296 132 183.196 132.2 183.096 132.4C182.996 132.5 182.896 132.6 182.796 132.6C182.696 132.6 182.596 132.5 182.496 132.5C182.696 132.1 182.896 131.6 183.196 131.1C183.196 131.3 183.196 131.5 183.296 131.7ZM185.196 128.9C185.296 128.7 185.396 128.5 185.596 128.3L185.796 128C185.896 128.4 185.796 128.8 185.796 129.2C185.596 129.3 185.396 129.5 185.196 129.6C185.096 129.3 185.096 129.1 185.196 128.9ZM187.296 126.1L187.896 125.1C187.896 125.4 187.896 125.8 187.896 126.2C187.696 126.3 187.496 126.5 187.296 126.6V126.1ZM189.696 126.6C189.696 126.3 189.796 126 189.896 125.8C189.996 125.5 190.196 125.2 190.396 125C190.496 125.4 190.396 125.8 190.196 126.3C190.096 126.4 189.896 126.5 189.696 126.6ZM188.696 127.9L188.996 127.5C189.096 127.8 189.096 128 189.096 128.1C189.096 128.3 188.996 128.6 188.896 128.8C188.796 129 188.696 129.1 188.596 129.1C188.496 129.2 188.396 129.2 188.296 129.1C188.196 128.8 188.396 128.4 188.696 127.9ZM192.096 126.6C192.396 126 192.696 125.6 192.796 125.4V126.2L192.596 126.6L192.296 126.9C192.196 126.9 192.096 126.8 192.096 126.6ZM196.396 119.2L175.696 131.2V155.1L196.396 143.1V119.2ZM174.696 130.6L197.396 117.5V143.7L174.696 156.8V130.6Z",
    fill: "#693319"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.696 144.8C154.796 143.6 157.796 141.8 161.896 139.5V150.2C161.896 150.4 161.896 150.7 161.796 150.9C161.796 151.2 161.696 151.6 161.496 151.9C161.296 152.3 161.096 152.6 160.796 152.9C160.396 153.4 159.896 153.9 159.296 154.3C158.896 154.6 158.396 155 157.696 155.4C157.696 155.7 157.696 156.9 157.696 159C157.696 160.5 157.696 161.7 157.696 162.6C158.196 162.4 158.696 162.1 159.496 161.6C160.496 161 160.996 160.7 161.296 160.6V161.6L152.996 166.4V165.4L156.396 163.4V156.1C155.796 156.4 155.296 156.7 154.896 156.8C154.296 157 153.896 157.1 153.396 157.1C153.196 157.1 152.996 157 152.796 156.8C152.696 156.6 152.596 156.4 152.596 156.1C152.596 154.7 152.596 152.8 152.596 150.5C152.696 147.6 152.696 145.8 152.696 144.8ZM145.996 172.6V146.4L168.696 133.3V159.5L145.996 172.6ZM167.696 158.9V135L146.996 147V170.9L167.696 158.9Z",
    fill: "#693319"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.596 159.7L128.196 165L125.796 166.4V179L123.196 180.5V167.8L120.996 169.1L124.596 159.7ZM128.596 164.7L132.096 155.3L135.696 160.6L133.296 162V174.6L130.696 176.1V163.4L128.596 164.7ZM136.796 173.4V175L120.396 184.5V183L136.796 173.4ZM138.996 150.8L118.296 162.8V186.6L138.996 174.6V150.8ZM117.296 162.1L139.996 149V175.2L117.296 188.3V162.1Z",
    fill: "#693319"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.696 106.9L202.396 54L231.496 92.6L139.696 145.5L110.696 106.9Z",
    fill: "#D2A06F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7964 53.7L113.496 106.6L99.2964 152.6L7.59644 99.6999L21.7964 53.7Z",
    fill: "#91633E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3443 52.5753L0 76.2802L1.33757 77.4845L22.6819 53.7796L21.3443 52.5753Z",
    fill: "#D2A06F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M202.435 53.8471L202.105 55.7183L235.293 61.5686L235.622 59.6974L202.435 53.8471Z",
    fill: "#91633E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.196 7.70001L235.496 59.8L202.596 54.1L112.296 2L145.196 7.70001Z",
    fill: "#ECBA89"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6964 53.7L112.096 105.9L97.9964 151.8L7.59644 99.6999L21.6964 53.7Z",
    fill: "#ECBA89"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.996 106L202.396 53.9L231.496 92.6L141.096 144.7L111.996 106Z",
    fill: "#B68156"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.196 106L21.8964 53.8999L23.9964 52.7L114.296 104.8L112.196 106Z",
    fill: "#F6CA9F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.196 106L109.996 104.7L200.296 52.6L202.496 53.9L112.196 106Z",
    fill: "#F6CA9F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0964 149L75.0964 159.4V178.6L57.0964 168.2V149Z",
    fill: "#91633E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0964 149L73.8965 158.7V178L57.0964 168.2V149Z",
    fill: "#ADA196"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/noData.921d038b83de410e67584d163f885abf.svg";
export { ForwardRef as ReactComponent };